module.exports = __webpack_public_path__ + "media/src/images/amazon-c73ebf28782171538ce597a2c2740965.png";